import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'
import type { ResponseMessage } from '../services/chatBotGetAIResponse'

interface SendTalkChatbotEventProps {
	id: number
	isAgent?: boolean
	responseMessages?: ResponseMessage[]
	isFashionAssistantRegenerate?: boolean
}
interface ChatbotTriggers {
	triggers: string[]
	subTriggers: string[]
}

export const sendTalkChatbotEvent = ({
	id,
	isAgent,
	responseMessages,
	isFashionAssistantRegenerate,
}: SendTalkChatbotEventProps): void => {
	if (isAgent) {
		sendGenericEvent('talk_chatbot', {
			index: id,
			type: 'written',
			triggers: 'agent',
			subtriggers: 'agent',
			action: 'first',
		})
	}
	const triggers = responseMessages?.reduce<ChatbotTriggers>(
		(acc, responseMessage) => {
			const trigger = responseMessage.payload.type
			const subtriggers: string[] = responseMessage.payload.responses.map(
				(response) => ('category' in response ? response.category : trigger)
			)
			acc.triggers.push(trigger)
			acc.subTriggers.push(subtriggers.join(','))
			return acc
		},
		{
			triggers: [],
			subTriggers: [],
		}
	)
	sendGenericEvent('talk_chatbot', {
		index: id,
		type: 'written',
		label_1: triggers?.triggers.join('|'),
		location: triggers?.subTriggers.join('|'),
		action: isFashionAssistantRegenerate ? 'regenerate' : 'first',
	})
}
